class TSProduct extends HTMLElement {
    constructor() {
        super(), this.cart = document.querySelector("ts-cart"), this.isLoading = !1, this.pages, this.pagesUrls = [], this.initSection(), this.initClickEvent(), this.initSubmitEvent(), this.initChangeEvent(), this.querySelectorAll("[data-page]").length === 2 && this.fetchPages()
    }
    changePage(index) {
        if (!this.pages) return;
        const newProductSection = this.pages[index].querySelector("ts-product");
        if (newProductSection) {
            this.innerHTML = newProductSection.innerHTML, this.classList = newProductSection.classList.value, this.initSection(), window.history.replaceState({}, "", window.location.origin + this.pagesUrls[index]);
            const newSections = this.pages[index].querySelectorAll("main .shopify-section");
            document.querySelectorAll("main .shopify-section").forEach((section, i) => {
                const newSection = newSections[i],
                    excludedSections = ["ts-product", ".ts-trust-reviews"];
                section.querySelector(excludedSections.join(",")) || (section.innerHTML = newSection.innerHTML, section.querySelectorAll("script").forEach(oldScript => {
                    if (!oldScript.src) {
                        const newScript = document.createElement("script");
                        newScript.textContent = oldScript.textContent, section.appendChild(newScript), oldScript.remove()
                    }
                }))
            })
        }
    }
    fetchPages() {
        this.querySelectorAll("[data-page]").forEach(pageToggle => {
            this.pagesUrls.push(pageToggle.dataset.page)
        }), Promise.all(this.pagesUrls.map(this.fetchHTML)).then(htmlArray => this.pages = htmlArray).catch(error => console.error("Error:", error))
    }
    fetchHTML(url) {
        return fetch(url).then(response => {
            if (!response.ok) throw new Error(`Error while fetching page ${url}`);
            return response.text()
        }).then(body => new DOMParser().parseFromString(body, "text/html"))
    }
    initSection() {
        if (this.galleryLightbox = this.querySelector(".ts-lightbox"), this.stickyBar = this.querySelector("#TSProductSticky"), this.productForm = this.querySelector("#TSProductForm"), this.productPrice = this.querySelector("#TSProductPrice"), this.productSubmit = this.querySelector("#TSProductSubmit"), this.productMessage = this.querySelector("#TSProductMessage"), this.backInStockPopup = this.querySelector("#TSProductBackInStock"), this.productVariants = JSON.parse(this.querySelector("#TSProductVariants").textContent), this.sliderWrapper = this.querySelector("[data-slider]"), this.comparePopup = this.querySelector(".ts-product__upgrade-popup"), this.mainSlider, this.variant = null, this.currentLightboxSlide = 1, this.querySelectorAll(".ts-product__disclosure-wrapper.open").forEach(disclosure => {
                const content = disclosure.querySelector(".ts-product__disclosure-content");
                content.style.maxHeight = content.scrollHeight + "px"
            }), this.galleryLightbox && this.initScrollEvent(), this.mainSlider = new Flickity(this.sliderWrapper, {
                cellAlign: "center",
                contain: !0,
                wrapAround: !0,
                prevNextButtons: !1,
                pageDots: !0,
                draggable: !0,
                watchCSS: !0
            }), this.initVideos(), this.stickyBar && this.productSubmit) {
            const needToShow = !this.isInViewport(this.productSubmit);
            this.stickyBar.classList.toggle("show", needToShow), window.addEventListener("scroll", () => {
                this.stickyBar.classList.toggle("show", !this.isInViewport(this.productSubmit))
            })
        }
    }
    variantChange() {
        this.addLoading();
        const searchParams = new URLSearchParams(window.location.search);
        let selectedValuesLabel = "";
        [1, 2, 3].forEach(option => {
            this.querySelector(`[data-option="${option}"]`) && (selectedValuesLabel += " / " + this.querySelector(`[data-option="${option}"] input:checked`).value)
        }), this.productVariants.forEach(variant => {
            variant.title === selectedValuesLabel.slice(3) && (this.variant = variant)
        }), this.productForm && (this.productForm.querySelector("[name='id']").value = this.variant.id), searchParams.set("variant", this.variant.id);
        const newProductUrl = window.location.origin + window.location.pathname + `?${searchParams.toString()}`;
        window.history.replaceState({}, "", newProductUrl), fetch(newProductUrl).then(res => res.text()).then(body => {
            const html = new DOMParser().parseFromString(body, "text/html");
            this.productPrice && (this.productPrice.innerHTML = html.querySelector("#TSProductPrice").innerHTML), this.productSubmit && (this.productSubmit.querySelector("[data-label]").innerText = html.querySelector("#TSProductSubmit [data-label]").innerText, this.backInStockPopup?.classList.remove("success"), html.querySelector("#TSProductSubmit").hasAttribute("data-trigger") ? (this.productSubmit.setAttribute("data-trigger", "backinstock"), this.productSubmit.classList.add("backinstock")) : (this.productSubmit.removeAttribute("data-trigger"), this.productSubmit.classList.remove("backinstock"))), this.removeLoading()
        }).catch(error => {
            console.error(error), this.removeLoading()
        })
    }
    changeLightboxSlide() {
        const slider = this.galleryLightbox.querySelector(".ts-lightbox__main"),
            controlPrev = this.galleryLightbox.querySelector("[data-trigger='zoom-prev']"),
            controlNext = this.galleryLightbox.querySelector("[data-trigger='zoom-next']"),
            allSlidesLength = slider.querySelectorAll(".ts-lightbox__media").length;
        slider.scrollTo({
            left: slider.querySelector(`.ts-lightbox__media:nth-child(${this.currentLightboxSlide})`).offsetLeft,
            behavior: "smooth"
        }), controlPrev.classList.toggle("disabled", this.currentLightboxSlide == 1), controlNext.classList.toggle("disabled", this.currentLightboxSlide == allSlidesLength)
    }
    addToCart(variantId = !1) {
        this.addLoading();
        const sections = [],
            itemId = variantId || parseInt(this.productForm.querySelector("[name='id']").value);
        let quantity = 1;
        this.cart && sections.push("ts-cart-drawer"), this.querySelector("[name='quantity']:checked") && (quantity = parseInt(this.querySelector("[name='quantity']:checked").value));
        const cartData = {
            items: [{
                id: itemId,
                quantity
            }],
            sections,
            sections_url: window.location.pathname
        };
        this.querySelectorAll(".added[data-upsell] [name='upsell_id']").forEach(select => {
            
            const quantitiesWrapper = document.querySelector(".ts-product__quantities");
            var upsell_qty = 1;
            if (quantitiesWrapper) {
                const checkedInput = quantitiesWrapper.querySelector("input[type='radio']:checked");
                if (checkedInput) {
                    upsell_qty = checkedInput.value;
                } else {
                    console.log("No checked input found.");
                }
            }
            

            cartData.items.push({
                id: parseInt(select.value),
                quantity: upsell_qty
            })
        }), this.querySelectorAll("[data-promotion] [name='promotion_product']").forEach(promo => {
            cartData.items.push({
                id: parseInt(promo.value),
                quantity: 1
            })
        }), this.querySelectorAll("[data-additional-product]").forEach(additional => {
            cartData.items.push({
                id: parseInt(additional.value),
                quantity: 1
            })
        }), fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(cartData)
        }).then(response => response.json()).then(response => {
            if (response.items) this.productMessage && (this.productMessage.innerHTML = ""), this.removeLoading(), this.cart ? (this.cart.renderContent(response.sections), this.cart.open()) : window.location.pathname = "/cart";
            else throw new Error(response.description)
        }).catch(error => {
            this.productMessage && (this.productMessage.innerHTML = error, setTimeout(() => {
                this.productMessage.innerHTML = ""
            }, 5e3)), this.removeLoading(), console.error(error)
        })
    }
    backInStockSubscribe() {
        const url = "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=RVj7fw",
            options = {
                method: "POST",
                headers: {
                    revision: "2024-02-15",
                    "Content-Type": "application/json",
                    "X-Klaviyo-Onsite": "1"
                },
                body: JSON.stringify({
                    data: {
                        type: "back-in-stock-subscription",
                        attributes: {
                            profile: {
                                data: {
                                    type: "profile",
                                    attributes: {
                                        email: this.backInStockPopup.querySelector("input[type='email']").value
                                    }
                                }
                            },
                            channels: ["EMAIL"]
                        },
                        relationships: {
                            variant: {
                                data: {
                                    type: "catalog-variant",
                                    id: "$shopify:::$default:::" + this.productForm.querySelector("[name='id']").value
                                }
                            }
                        }
                    }
                })
            };
        fetch(url, options).then(res => {
            res.ok ? this.backInStockPopup.classList.add("success") : console.error("Error when try to add back in stock")
        }).catch(error => {
            console.error(error)
        })
    }
    initClickEvent() {
        this.addEventListener("click", e => {
            if (e.target.hasAttribute("data-trigger")) {
                const promoBlock = e.target.closest("[data-promotion]"),
                    promoOptions = promoBlock?.querySelector("[promotion-options]") || !1;
                switch (e.target.getAttribute("data-trigger")) {
                    case "disclosure":
                        const disclosureWrapper = e.target.closest(".ts-product__disclosure-wrapper"),
                            disclosureContent = e.target.nextElementSibling,
                            previousDisclosureWrapper = this.querySelector(".ts-product__disclosure-wrapper.open");
                        previousDisclosureWrapper && previousDisclosureWrapper !== disclosureWrapper && (previousDisclosureWrapper.classList.remove("open"), previousDisclosureWrapper.querySelector(".ts-product__disclosure-content").style.maxHeight = null), disclosureWrapper.classList.toggle("open"), disclosureContent.style.maxHeight = disclosureWrapper.classList.contains("open") ? disclosureContent.scrollHeight + "px" : null;
                        break;
                    case "tab":
                        document.querySelector(".ts-product__tabs-heading.selected")?.classList.remove("selected"), document.querySelector(".ts-product__tabs-block.selected")?.classList.remove("selected"), e.target.classList.add("selected"), document.querySelector(`.ts-product__tabs-block[data-tab="${e.target.dataset.tab}"]`).classList.add("selected");
                        break;
                    case "video-toggle":
                        const toggleVideoElement = e.target.closest(".ts-product__media--video"),
                            toggleVideo = toggleVideoElement.querySelector("video");
                        toggleVideoElement.classList.toggle("play"), toggleVideoElement.classList.contains("play") ? toggleVideo.play() : toggleVideo.pause();
                        break;
                    case "volume":
                        const volumeVideoElement = e.target.closest(".ts-product__media--video"),
                            volumeVideo = volumeVideoElement.querySelector("video");
                        volumeVideoElement.classList.toggle("volume-on"), volumeVideo.muted = !volumeVideoElement.classList.contains("volume-on");
                        break;
                    case "description":
                        const description = e.target.previousElementSibling;
                        e.target.classList.toggle("active"), description.style.maxHeight = e.target.classList.contains("active") ? description.scrollHeight + "px" : "100px";
                        break;
                    case "zoom":
                        this.galleryLightbox.classList.add("open"), this.currentLightboxSlide = parseInt(e.target.dataset.slide), setTimeout(this.changeLightboxSlide.bind(this), 300);
                        break;
                    case "zoom-close":
                        this.galleryLightbox.classList.remove("open");
                        break;
                    case "zoom-nav":
                        this.currentLightboxSlide = parseInt(e.target.dataset.slide), this.changeLightboxSlide();
                        break;
                    case "zoom-prev":
                        this.currentLightboxSlide > 1 && (this.currentLightboxSlide -= 1, this.changeLightboxSlide());
                        break;
                    case "backinstock":
                        this.backInStockPopup && (e.preventDefault(), this.backInStockPopup.classList.add("open"), document.documentElement.style.overflow = "hidden", document.querySelector(".intercom-lightweight-app")?.classList.remove("active"));
                        break;
                    case "back-close":
                        this.backInStockPopup && (this.backInStockPopup.classList.remove("open"), document.documentElement.style.overflow = null);
                        break;
                    case "sticky-add":
                        this.addToCart();
                        break;
                    case "zoom-next":
                        const slidesSize = this.galleryLightbox.querySelectorAll(".ts-lightbox__main img").length;
                        this.currentLightboxSlide < slidesSize && (this.currentLightboxSlide += 1, this.changeLightboxSlide());
                        break;
                    case "bundle-close":
                        e.target.closest("[data-popup]")?.classList.remove("open"), e.target.classList.remove("open"), document.documentElement.style.overflow = null;
                        break;
                    case "bundle-popup":
                        const bundlePopupId = e.target.closest("[data-product]").dataset.product,
                            bundlePopup = this.querySelector(`[data-popup="${bundlePopupId}"]`);
                        bundlePopup && (bundlePopup.classList.add("open"), document.documentElement.style.overflow = "hidden");
                        break;
                    case "change-page":
                        this.changePage(parseInt(e.target.getAttribute("data-page-index")));
                        break;
                    case "upgrade-popup-open":
                        this.comparePopup.classList.add("open"), document.documentElement.style.overflow = "hidden";
                        break;
                    case "upgrade-popup-close":
                        this.comparePopup.classList.remove("open"), document.documentElement.style.overflow = null;
                        break;
                    case "add-upgrade":
                        this.comparePopup.classList.remove("open"), document.documentElement.style.overflow = null, this.addToCart(parseInt(e.target.dataset.variant));
                        break;
                    case "upsell-add":
                        e.target.closest("[data-upsell]").classList.toggle("added");
                        break;
                    case "offer-submit":
                        const toggleButton = this.querySelector(".ts-product__offer-toggle");
                        this.querySelector("#TSBundleOffer").classList.remove("open"), toggleButton.classList.add("active"), this.productForm.querySelector("[name='id']").value = toggleButton.dataset.bundle, document.documentElement.style.overflow = null, this.productSubmit.click();
                        break;
                    case "offer-toggle":
                        e.target.classList.toggle("active"), this.productForm.querySelector("[name='id']").value = e.target.classList.contains("active") ? e.target.dataset.bundle : e.target.dataset.product;
                        break;
                    case "offer-open":
                        this.querySelector("#TSBundleOffer").classList.add("open"), document.documentElement.style.overflow = "hidden";
                        break;
                    case "offer-close":
                        this.querySelector("#TSBundleOffer").classList.remove("open"), document.documentElement.style.overflow = null;
                        break;
                    case "toggle-promo":
                        promoBlock.classList.toggle("open"), promoOptions.style.maxHeight = promoBlock.classList.contains("open") ? promoOptions.scrollHeight + "px" : null;
                        break;
                    case "select-promo":
                        if (e.target.classList.contains("disabled")) break;
                        const promoCurrent = promoBlock.querySelector("[promo-current]"),
                            currentPromoMedia = promoCurrent.querySelector(".ts-product__promotion-media"),
                            currentPromoTitle = promoCurrent.querySelector(".ts-product__promotion-product-title"),
                            currentPromoDescription = promoCurrent.querySelector(".ts-product__promotion-product-description"),
                            newPromoMedia = e.target.querySelector(".ts-product__promotion-media"),
                            newPromoTitle = e.target.querySelector(".ts-product__promotion-product-title"),
                            newPromoDescription = e.target.querySelector(".ts-product__promotion-product-description");
                        currentPromoMedia.innerHTML = newPromoMedia.innerHTML, currentPromoTitle.innerText = newPromoTitle.innerText, currentPromoDescription.innerText = newPromoDescription.innerText, promoBlock.querySelector('[name="promotion_product"]').value = e.target.dataset.product, promoBlock.querySelector(".active").classList.remove("active"), promoBlock.classList.remove("open"), promoOptions.style.maxHeight = null, e.target.classList.add("active");
                        break
                }
            }
        })
    }
    initSubmitEvent() {
        this.addEventListener("submit", e => {
            e.preventDefault(), e.target.id == "TSProductBackInStockForm" ? this.backInStockSubscribe() : this.addToCart()
        })
    }
    initChangeEvent() {
        this.addEventListener("change", e => {
            if (e.target.name == "quantity") this.productPrice.querySelector(".ts-price--main").innerText = e.target.dataset.price;
            else if (e.target.name == "upsell_id") {
                const upsellProduct = e.target.closest("[data-upsell]"),
                    option = e.target.options[e.target.selectedIndex];
                upsellProduct.querySelector(".ts-price--compare").innerHTML = option.dataset.compare, upsellProduct.querySelector(".ts-price--main").innerHTML = option.dataset.price
            } else this.variantChange(), this.querySelector("[name='quantity'][value='1']") && (this.querySelector("[name='quantity'][value='1']").checked = !0)
        })
    }
    initScrollEvent() {
        const mainLightboxGallery = this.galleryLightbox.querySelector(".ts-lightbox__main"),
            navLightboxGallery = this.galleryLightbox.querySelector(".ts-lightbox__navs");
        mainLightboxGallery.addEventListener("scroll", () => {
            const slideWidth = mainLightboxGallery.querySelector(".ts-lightbox__media").clientWidth,
                index = Math.round(mainLightboxGallery.scrollLeft / slideWidth);
            window.innerWidth < 750 && navLightboxGallery.scrollTo({
                left: navLightboxGallery.querySelector(`.ts-lightbox__media:nth-child(${index+1})`).offsetLeft,
                behavior: "smooth"
            })
        })
    }
    addLoading() {
        this.isLoading = !0, this.classList.add("loading")
    }
    removeLoading() {
        this.isLoading = !1, this.classList.remove("loading")
    }
    isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    }
    initVideos() {
        this.querySelectorAll(".ts-product__media--video").forEach(videoElement => {
            videoElement.classList.add("play"), videoElement.querySelector("video").play()
        })
    }
}
customElements.define("ts-product", TSProduct);

document.addEventListener('DOMContentLoaded', function() {
    const notifyBtn = document.getElementById('notifyme');
    const notifyForm = document.querySelector('.notify-form .ts-footer__field-wrapper');

    notifyBtn.addEventListener('click', function() {
        // If already visible, do nothing
        if (notifyForm.style.display === 'block') return;

        // Set initial state
        notifyForm.style.display = 'block';
        notifyForm.style.height = '0px';
        notifyForm.style.overflow = 'hidden';

        // Get actual height for animation
        const targetHeight = notifyForm.scrollHeight + 'px';

        // Animate height
        requestAnimationFrame(() => {
            notifyForm.style.transition = 'height 0.3s ease';
            notifyForm.style.height = targetHeight;
        });

        // Clean up after animation
        notifyForm.addEventListener('transitionend', function handler() {
            notifyForm.style.height = 'auto';
            notifyForm.style.overflow = '';
            notifyForm.style.transition = '';
            notifyForm.removeEventListener('transitionend', handler);
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const dynamicDates = document.querySelector("dynamic-dates");
  if (!dynamicDates) return;

  const dateFormat = dynamicDates.dataset.dateFormat || "dd_mm_no_dot";
  const dayLabels = dynamicDates.dataset.dayLabels.split(",").map(label => label.trim());
  const monthLabels = dynamicDates.dataset.monthLabels.split(",").map(label => label.trim());

  const checkpoints = dynamicDates.querySelectorAll("[data-dynamic-date='true']");

  checkpoints.forEach((checkpoint) => {
    const minDays = parseInt(checkpoint.dataset.minDays, 10) || 0;
    const maxDays = parseInt(checkpoint.dataset.maxDays, 10) || 0;

    // Calculate target date (today + maxDays)
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + maxDays);

    const dayOfWeek = dayLabels[targetDate.getDay() === 0 ? 6 : targetDate.getDay() - 1]; // Sunday fix
    const day = targetDate.getDate();
    const month = monthLabels[targetDate.getMonth()];

    // Format date according to dd_mm_no_dot
    const formattedDate = `${day}  ${month}`;

    // Replace placeholders
    let textTemplate = checkpoint.dataset.text;
    if (textTemplate.includes("[start_date]")) {
      textTemplate = textTemplate.replace("[start_date]", formattedDate);
    }
    if (textTemplate.includes("[end_date]")) {
      textTemplate = textTemplate.replace("[end_date]", formattedDate);
    }

    // Update element content
    checkpoint.innerHTML = textTemplate;
  });
});
